<template>
  <div class="min-h-[70vh] flex items-center justify-center px-4">
    <Card
      class="max-w-4xl w-full p-8 shadow-2xl rounded-3xl bg-gradient-to-br from-white to-slate-50 dark:from-gray-800 dark:to-gray-900 border border-gray-100 dark:border-gray-700"
    >
      <template #content>
        <div class="text-center">
          <!-- Larger animated spinner -->
          <div class="mb-6">
            <div class="relative w-28 h-28 mx-auto">
              <div
                class="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-500 border-r-indigo-500 animate-spin"
              ></div>
              <div
                class="absolute inset-2 rounded-full border-4 border-transparent border-b-green-500 border-l-purple-500 animate-spin"
                style="animation-direction: reverse"
              ></div>
              <div
                class="absolute inset-4 rounded-full bg-gradient-to-br from-blue-600 to-indigo-700 flex items-center justify-center shadow-md"
              >
                <i class="pi pi-search text-white text-2xl"></i>
              </div>
            </div>
          </div>

          <h3 class="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-2">
            {{ title }}
          </h3>
          <p class="text-lg text-slate-600 dark:text-slate-400 mb-4">
            {{ subtitle }}
          </p>

          <p class="text-sm text-slate-500 dark:text-slate-400 mb-6">
            {{ info }}
          </p>

          <div class="flex items-center justify-center gap-4">
            <Button
              label="Geri"
              icon="pi pi-arrow-left"
              class="p-button-outlined"
              @click="geriTikla"
            />
            <Button
              label="Ana Sayfa"
              icon="pi pi-home"
              @click="$router.push('/')"
            />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { geriGit } from "@/services/geriNavigasyon";

export default {
  name: "YetkiYok",
  components: {},
  props: {
    title: { type: String, default: "Yetkiniz Yok" },
    subtitle: { type: String, default: "Şubeler ile ilgili gerekli yetkiniz yok." },
    info: { type: String, default: "Yöneticiniz ile iletişime geçin." },
  },
  methods: {
    geriTikla() {
      geriGit(this.$router, this.$route, "/admin/main");
    },
  },
};
</script>
